// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.css-1t1j96h-MuiPaper-root-MuiDialog-paper {
  width: 428px;
}

.css-1t4vnk2-MuiDialogContent-root {
  border-top: none;
  border-bottom: none;
}`, "",{"version":3,"sources":["webpack://./src/shared-component/DeletePopup/style.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;AACJ;;AAEA;EACI,gBAAA;EACA,mBAAA;AACJ","sourcesContent":[".css-1t1j96h-MuiPaper-root-MuiDialog-paper {\r\n    width:428px;\r\n}\r\n\r\n.css-1t4vnk2-MuiDialogContent-root{\r\n    border-top: none;\r\n    border-bottom:none;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
